angular.module('bmsApp.trugreen.inventory').factory('TGInventorySvc', function (CRUDSvc) {

	var self = {
		index: function (params) {
			return CRUDSvc.get('api/trugreen/inventory/index', params);
		},
		read: function (params) {
			return CRUDSvc.get('api/trugreen/inventory/read', params);
		},
		save: function (params) {
			return CRUDSvc.post('api/trugreen/inventory/save', params);
		}
	};
	return self;

});
